// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {createContext, useEffect, useMemo, useState} from 'react';
import {get_aliased_pathname, use_pathname} from './lib/use_pathname';
import etask from 'zetask';
import {qs_parse} from 'zurl';
import {useLocation} from 'react-router-dom';

export const statuses = {
    pending: 'pending',
    error: 'error',
    done: 'done',
    unavailable: 'unavailable',
};

let data_cache = {};
export const Data_context = createContext({} as object_of<any>);

export const Data_provider = ({data_for_render, children, route}:any)=>{
    const {params} = use_pathname();
    const {search, pathname: current_pathname} = useLocation();
    const pathname = get_aliased_pathname(current_pathname);
    const qs_o = qs_parse(search.substr(1), {safe: true});
    const full_params = {...params, ...qs_o};
    const [refresh, set_refresh] = useState(1);
    const initial_data_state = Array.isArray(data_for_render) ?
    data_for_render.reduce((acc, cur_val)=>{
      if (cur_val && 'cache_key' in cur_val && cur_val.cache_key)
      {
        acc[cur_val.cache_key] = {
          result: cur_val as object_of<any>,
          status: statuses.done,
        };
      }
      return acc;
    }, {}) : {};
    const [state, set_state] = useState({
        ...initial_data_state,
        refresh_by_loaded: refresh,
        reset: ()=>{
            set_refresh(r=>r+1);
            set_state(s=>({...s, refresh_by_loaded: s.refresh_by_loaded+1}));
        },
        clear_cache: ()=>{
            data_cache = {};
        },
    });
    const memo_state = useMemo(()=>({
        inited: false,
        loader_timers: {} as object_of<any>,
    }), []);
    useEffect(()=>{
        const data_id = route && route.get_data_id
            && route.get_data_id(full_params, pathname) || '';
        if (!data_id)
            return;
        if (data_for_render && !memo_state.inited)
        {
            if (route.set_data_cache && data_for_render[0])
            {
                route.set_data_cache(data_cache, full_params,
                    data_for_render[0],
                    pathname);
            }
            memo_state.inited = true;
        }
        if (route.data_provider)
        {
            if (memo_state.loader_timers[data_id])
                return;
            memo_state.loader_timers[data_id] = setTimeout(()=>{
                set_state(old=>({...old, [data_id]: {
                    status: statuses.pending,
                    result: null,
                }}));
            }, 200);
            etask(function*(){
                const data = yield route.data_provider(data_cache,
                    full_params, pathname);
                clearTimeout(memo_state.loader_timers[data_id]);
                memo_state.loader_timers[data_id] = undefined;
                set_state(old=>({...old, [data_id]: {
                    status: statuses.done,
                    result: data,
                }}));
            });
        }
    }, [JSON.stringify(full_params), pathname,
        route.has_data_provider && route.data_provider, refresh]);
    return <Data_context.Provider value={state}>
      {children}
    </Data_context.Provider>;
};
